import menus from "../../../router/menus";
import {createElement} from "react";
import {Link, useLocation} from "react-router-dom";

import Alert from "../../../helpers/Alert";
import Storage from "../../../helpers/Storage";
export default function SideBar() {
    const { pathname: currentPath } = useLocation();
    const validatePage = currentPath.split('/');
    /*console.log(currentPath,validatePage, '/'+validatePage[0] === menu.path && '/'+validatePage[1] === menu.path);*/



    return(
        <aside id="default-sidebar" className="w-80 h-[calc(100vh_-_80px)]  md:block bg-[#082a32] xs:hidden overflow-auto" aria-label="Sidebar">
            <div className="h-full overflow-auto bg-[#082a32] text-[14px] font-normal ">
                <ul className="mt-5">
                    {
                        menus.map((menu, index) => {
                            if (menu.private){
                                return(
                                    <li className={'mt-1'}>
                                        <Link to={menu.path ? menu.path : ''}  className={`flex items-center px-2 group `}>
                                            <div className={`flex items-center gap-2 text-white rounded-md w-full p-3 hover:bg-[#003641] ${(validatePage[0] ? ('/'+validatePage[0] === menu.path || currentPath === menu.path): currentPath === menu.path) ? 'bg-[#003641] font-bold ' : ''}`}>
                                                {menu.icon ? <menu.icon className={'w-[20px] h-[20px]'} /> : ''}<span className="">{menu.title}</span>
                                            </div>
                                        </Link>

                                    </li>
                                )
                            }

                        })
                    }
                </ul>
            </div>
        </aside>
    )
}